import { useQuery } from '@tanstack/react-query'

import { ArticlePreview } from '@/components/common/ArticlePreview'
import { LoadingMask } from '@/components/common/LoadingMask'
import { type WPPostPreviewType } from '@/defs/wordpress'
import { fetchApi } from '@/utils/requestUtil'

import styles from './EmbedArticle.module.scss'

type Props = {
  slug: string
}

export const EmbedArticle = ({ slug }: Props) => {
  const {
    data: article,
    isError,
    isPending,
  } = useQuery({
    queryFn: async () =>
      (await fetchApi<WPPostPreviewType>({ base: 'internal', path: `/articles/embed/${slug}` })).data,
    queryKey: ['article-embed', slug],
  })

  return (
    <div className={styles.container}>
      {article && <ArticlePreview article={article} showBg showCategory />}
      {isError && <div className={styles.error}>Error Loading Post</div>}
      <LoadingMask loading={isPending} />
    </div>
  )
}
